module.exports = "https://static.wmbcdn.com/uniweb/images/4f0aa81599172e1cb23fb82afdc6e7c1.svg";